import { isBugBountyParticipant } from '@atlassian/amkt-common';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { CloudFortifiedAppBadge, CloudFortifiedAppBadgeSources } from '../../../CloudFortifiedAppBadge';
import { CloudSecurityParticipantBadge } from '../../../CloudSecurityParticipantBadge';
import { RunsOnAtlassianBadge } from '../../../RunsOnAtlassianBadge/RunsOnAtlassianBadge';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Renders either the "Cloud Fortified" or "Cloud Security Participant" badge,
 * whichever is applicable, with preference to the former when both are applicable.
 */
const HeaderCertificationBadge = props => {
  if (props.isAppCloudFortified) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [props.isRunsOnAtlassianApp && /*#__PURE__*/_jsx(RunsOnAtlassianBadge, {}), /*#__PURE__*/_jsx(CloudFortifiedAppBadge, {
        showLabel: true,
        source: CloudFortifiedAppBadgeSources.AppListing
      })]
    });
  }
  if (isBugBountyParticipant(AtlassianProductHostingType.Cloud, props.bugBountyParticipant)) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [props.isRunsOnAtlassianApp && /*#__PURE__*/_jsx(RunsOnAtlassianBadge, {}), /*#__PURE__*/_jsx(CloudSecurityParticipantBadge, {
        showLabel: true
      })]
    });
  }
  return props.isRunsOnAtlassianApp ? /*#__PURE__*/_jsx(RunsOnAtlassianBadge, {}) : null;
};
export default HeaderCertificationBadge;